module.exports = __webpack_public_path__ + "static/media/productos_botanas_maiz_queso.00763feb.png";